import React,{useState} from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import './ProfileSetting.css';
import ModalComp from './ModalComp.js';
// react icons
import { BsGlobe } from 'react-icons/bs';
import { AiOutlineMenu } from 'react-icons/ai';
import { FaRegUserCircle } from 'react-icons/fa';
import { flexCenter } from 'themes/commonStyles';

const ProfileSettings = () => {

  const [open,setOpen] = useState(false)
  const [openModal,setOpenModal] = useState(false)
  const [opener,setOpener] = useState('Sign up')

  const handlePopUp =()=>{
  setOpen(!open)
}

  const handleModal =(type)=>{
    setOpener(type);
    setOpenModal(true)
  }

  return (
    <>
    <Box sx={flexCenter}>
      <Link href="#"> Become A Host</Link>
      <Stack>
        <Button>
          <BsGlobe size={24} />
        </Button>
        <Button
          sx={{
            borderRadius: 10,
            border: '1px solid #ddd',
          }}
          onClick={handlePopUp}
        >
          <Stack>
            <AiOutlineMenu size={24} />
            <FaRegUserCircle size={24} />
          </Stack>
        </Button>
      </Stack>
    </Box>
{
open &&
    <div className='popupMain'>
      <p className='signUpTxt' onClick={()=>handleModal('Sign up')}>Sign up</p>
      <p className='LogInTxt' onClick={()=>handleModal('Log in')}>Log in</p>
      <hr className='popupHr' />
      <p>Host your name</p>
      <p>Host an experience</p>
      <p>Help</p>
    </div>
}
<ModalComp opener={opener} setOpenModal={setOpenModal} openModal={openModal} />
    </>
  );
};

export default ProfileSettings;
